(() => {
  'use strict';

  const addBusinessDays = (date, days) => {
    const result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return result;
  };

  const formatDate = (date, withWeekday = true) => {
    const options = withWeekday
      ? { weekday: 'short', day: '2-digit', month: 'short' }
      : { day: '2-digit', month: 'short' };
    return new Intl.DateTimeFormat('de-DE', options).format(date).replace(',', '');
  };

  const updateDeliveryEstimates = (root = document) => {
    root.querySelectorAll('.cc-delivery-estimate').forEach((el) => {
      const now = new Date();
      const cutoffHour = Number(el.dataset.cutoffHour || 14);
      const orderShift = now.getHours() >= cutoffHour ? 1 : 0;
      const shipMin = Number(el.dataset.shipMin || 1) + orderShift;
      const shipMax = Number(el.dataset.shipMax || 2) + orderShift;
      const deliveryMin = Number(el.dataset.deliveryMin || 3) + orderShift;
      const deliveryMax = Number(el.dataset.deliveryMax || 5) + orderShift;

      const shipStart = addBusinessDays(now, shipMin);
      const shipEnd = addBusinessDays(now, shipMax);
      const deliveryStart = addBusinessDays(now, deliveryMin);
      const deliveryEnd = addBusinessDays(now, deliveryMax);

      const shipTarget = el.querySelector('[data-cc-ship-window]');
      const deliveryTarget = el.querySelector('[data-cc-delivery-window]');
      const cutoffTarget = el.querySelector('[data-cc-cutoff-copy]');

      if (shipTarget) shipTarget.textContent = `${formatDate(shipStart)} – ${formatDate(shipEnd)}`;
      if (deliveryTarget) deliveryTarget.textContent = `${formatDate(deliveryStart)} – ${formatDate(deliveryEnd)}`;
      if (cutoffTarget) {
        cutoffTarget.textContent = now.getHours() < cutoffHour
          ? `Bestellung bis ${String(cutoffHour).padStart(2, '0')}:00 Uhr wird in der Prognose für heute berücksichtigt.`
          : `Bestellungen nach ${String(cutoffHour).padStart(2, '0')}:00 Uhr werden ab dem nächsten Werktag eingeplant.`;
      }
    });
  };

  const initFitFinder = (root = document) => {
    root.querySelectorAll('[data-cc-fit-finder]').forEach((finder) => {
      if (finder.dataset.initialized === 'true') return;
      finder.dataset.initialized = 'true';

      const buttons = finder.querySelectorAll('[data-cc-fit-choice]');
      const panels = finder.querySelectorAll('[data-cc-fit-panel]');

      const select = (value) => {
        buttons.forEach((button) => {
          const active = button.dataset.ccFitChoice === value;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        panels.forEach((panel) => {
          const active = panel.dataset.ccFitPanel === value;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        const activePanel = finder.querySelector(`[data-cc-fit-panel="${value}"]`);
        if (activePanel) activePanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      };

      buttons.forEach((button) => button.addEventListener('click', () => select(button.dataset.ccFitChoice)));
    });
  };

  const init = (root = document) => {
    updateDeliveryEstimates(root);
    initFitFinder(root);
  };

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('cart:refresh', () => setTimeout(() => init(document), 120));
  document.addEventListener('variant:change', () => setTimeout(() => updateDeliveryEstimates(document), 80));
})();
